import {FormControl, InputLabel, MenuItem, Select, SelectChangeEvent} from '@mui/material';
import React, {useContext} from 'react';
import ZeiterfassungDashboardContext from '../../../../../Contexts/ZeiterfassungDashboardContext/ZeiterfassungDashboardContext';

function FilterBauvorhaben() {
  const {availableBauvorhaben, filter, dispatchFilter, isLoading} = useContext(
    ZeiterfassungDashboardContext
  );

  // Handler for bauvorhaben selection change
  const handleChange = React.useCallback(
    (event: SelectChangeEvent) => {
      const newBauvorhaben = event.target.value;
      dispatchFilter({
        type: 'SET_BAUVORHABEN',
        payload: newBauvorhaben,
      });
    },
    [dispatchFilter]
  );

  // If no bauvorhaben available or loading, disable the select
  const isDisabled = availableBauvorhaben.length === 0 || isLoading;

  return (
    <FormControl sx={{m: 1, minWidth: 250}} disabled={isDisabled}>
      <InputLabel id='bauvorhaben-select-label'>Bauvorhaben</InputLabel>
      <Select
        labelId='bauvorhaben-select-label'
        id='bauvorhaben-select'
        value={filter.bauvorhaben}
        MenuProps={{
          autoFocus: false,
        }}
        onChange={handleChange}
        label='Bauvorhaben'>
        <MenuItem value=''>
          <em>Alle</em>
        </MenuItem>
        {availableBauvorhaben.map((bvh) => (
          <MenuItem key={bvh} value={bvh}>
            {bvh}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

export default React.memo(FilterBauvorhaben);
